import { render, staticRenderFns } from "./textEditor.vue?vue&type=template&id=7ff90540&"
import script from "./textEditor.vue?vue&type=script&lang=ts&"
export * from "./textEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports